import { Link } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => {
    const title = "JaseOwns - Gaming - Ultima Online";
    const description = "Ultima Online came out in September 1997, I remember bugging my dad about getting it while playing Diablo 1 on Battle.NET as people online were talking about this new game.";
    return [
    { title: title },
    { description: description},
    { name: "keywords", content: "ultima online,creator,videos,uo,ultima online,1997"},
    { property: "og:image", content: "https://jaseowns.com/images/uo-feels.jpg"},
    { property: "og:image:alt", content: "Ultima Online Wallpaper"},
    { property: "twitter:card", content: "summary"},
    { property: "twitter:creator", content: "@jaseowns"},
    { property: "twitter:site", content: "@jaseowns"},
    { property: "og:title", content: title},
    { property: "og:description", content: description},
]}

export default function MageIndex() {
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="gaming">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">
                    <Link to="/gaming" className="underline">Gaming</Link> - <Link to="/gaming/ultima-online" className="underline">Ultima Online</Link> - <Link to="/gaming/ultima-online/new-player-guides" className="underline">New Player Guides</Link> - Arcane Mage - Blood Aspect
                </h1>
                <div className="px-10">
                <div className="my-6">
                        <div className="grid grid-cols-2 p-4 border border-blue-400">
                            <div>
                                <h3 className="my-4 text-3xl text-cyan-900 dark:text-cyan-200">Blood Aspect Spellbook</h3>
                                <div className="grid grid-cols-2"><span>Mana Refund Chance</span> 10% + 2% per player Blood Tier Level</div>
                                <div className="grid grid-cols-2"><span>Damage Bonus</span>	10% + 2% per player Blood Tier Level</div>
                                <div className="grid grid-cols-2">
                                    <span>Aspect Special Chance</span>
                                    (scales with spell circle)	4% + 0.4% per player Blood Tier Level
                                </div>
                                <div className="grid grid-cols-2">
                                    <span>Aspect Special Effect</span>
                                    Ravage	Inflicts (1000 + (100 * Tier Level)) irresistable bleed damage divided among creatures within a 4 tile radius
                                </div>
                            </div>

                            <div>
                                <h3 className="my-4 text-3xl text-cyan-900 dark:text-cyan-200">Blood Aspect Armor</h3>
                                <div className="grid grid-cols-2"><span>Armor Rating Bonus</span>	20% + 5% per player Blood Tier Level</div>
                                <div className="grid grid-cols-2"><span>Damage Bonus to Creatures below 50% HP</span>	10% + 3% per player Blood Tier Level</div>
                                <div className="grid grid-cols-2"><span>Chance to Inflict Irresistible Bleed on Melee or Spell*</span>	5% + 1.5% per player Blood Tier Level</div>
                                <div className="grid grid-cols-2"><span>All Stats Increase</span>	12 + 1.5 per player Blood Tier Level</div>
                            </div>
                        </div>
                        <h3 className="my-4 text-3xl text-cyan-900 dark:text-cyan-200">Why Blood Aspect?</h3>
                        <div>
                            We want to use the Blood Aspect because it has a chance to refund mana and do extra damage.  The armor bonus is also nice and the bleed effect is a nice bonus.
                        </div>
                        {/* <iframe width="560" height="315" className="float-left md:w-1/2 m-2 px-4"  src="https://www.youtube.com/embed/fKN8hzsLT_I?si=LfrxsYQpDqoMTier" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        <h2 className="text-3xl px-10 my-6 text-cyan-900 dark:text-cyan-200">UO Outlands - New Solo Player - Arcane Mage - Blood Aspect</h2>
                        <div className="mx-8 lg:px-4 my-4">
                               This playlist is for all the episodes of us being a brand new player on UO Outlands and making an <b>arcane mage</b> character.  We cover how to play and enjoy the game without any help or overnight macroing.
                        </div> */}
                    </div>
                  </div>
			</section>


			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4 clear-both">
				{WatchCTA()}
			</div>
		</div>
	)
}


